import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

import type { CookieConsentState } from './types'

const initialState: CookieConsentState = {
  scdValue: null,
}

export const cookieConsentSlice = createSlice({
  name: 'cookieConsent',
  initialState,
  reducers: {
    setScdValue: (state, action: PayloadAction<string>) => {
      if (state.scdValue === null) {
        state.scdValue = action.payload
      }
    },
  },
})

export type ActionsTypes = ReturnType<typeof cookieConsentSlice.actions.setScdValue>
export const { actions } = cookieConsentSlice
export default cookieConsentSlice.reducer
